import React from "react";
const Description = ({children}) => {
  const style = {
    paddingBottom:16,
    marginBottom:16,
  }
   const hr = {
        width: 'calc(100% + 64px)',
        height:1,
        position: 'absolute',
        left: -32,
        bottom: 0,
        background:'#F0F2FF',
    }
  return(
      <div className="relative">
        <p  style={style} className="mt-3 dark-gary-2 f14">{children}</p>
        <div style={hr}/>
      </div>
  )
}
export default Description;